export { default } from "ember-stereo/helpers/sound-start-timestamp";
